export default __webpack_public_path__ + "static/media/north_west.92ffce4a.svg";